module.exports = __webpack_public_path__ + "static/media/tlyfe-video-mock.a5679b87.png";